// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"d4de4761","260":"0f77c6db"}[chunkId] + ".chunk.css";
};